import PropTypes from "prop-types";
import classNames from "classnames";
import ReactPaginate from "react-paginate";
import prevArrow from "../../assets/icons/prev.svg";
import nextArrow from "../../assets/icons/next.svg";
import classes from "./Pagination.module.css";

const Pagination = (props) => {
  const { className, total, pageSize, currentPage, onPageChange } = props;

  const pageCount = Math.ceil(total / pageSize);

  const pageChangedHandler = (event) => {
    onPageChange(event.selected);
  };

  return (
    <ReactPaginate
      containerClassName={classNames(classes["pagination__pages"], className)}
      nextLabel={
        <img
          src={nextArrow}
          className={classes["pagination__arrow"]}
          alt="next"
        />
      }
      nextClassName={classes["pagination__next-item"]}
      nextLinkClassName={classes["pagination__next-item-link"]}
      previousLabel={
        <img
          src={prevArrow}
          className={classes["pagination__arrow"]}
          alt="prev"
        />
      }
      previousClassName={classes["pagination__prev-item"]}
      previousLinkClassName={classes["pagination__prev-item-link"]}
      pageClassName={classes["pagination__page"]}
      activeClassName={classes["pagination__page--active"]}
      pageLinkClassName={classNames(
        classes["pagination__page-link"],
        "numeric-content"
      )}
      forcePage={currentPage}
      onPageChange={pageChangedHandler}
      pageRangeDisplayed={3}
      marginPagesDisplayed={2}
      pageCount={pageCount}
      renderOnZeroPageCount={null}
      breakLabel="..."
      breakClassName={classes["pagination__break-item"]}
      breakLinkClassName={classes["pagination__break-item-link"]}
    />
  );
};

export default Pagination;

Pagination.propTypes = {
  className: PropTypes.string,
  total: PropTypes.number,
  pageSize: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
};
